__turbopack_context__.v({
  "className": "ML5_kW_className",
  "variable": "ML5_kW_variable",
});
